import { api } from '@/api/client';
import type { ApiResponse } from '@/types/auth';

export const AUDIT_TRAIL_SOURCES = [
  'user',
  'workspace',
  'automation',
  'chat',
  'hourly_budget',
  'bid_snapshot',
] as const;

export type AuditTrailSource = (typeof AUDIT_TRAIL_SOURCES)[number];

export type AuditTrailEvent = {
  id: string;
  createdAt: string | null;
  profileId: string;
  accountName: string | null;
  source: AuditTrailSource | string;
  sourceId: string | null;
  sourceLabel: string | null;
  actorUserId: string | null;
  actorEmail: string | null;
  entityType: string;
  entityId: string | null;
  entityName: string | null;
  action: string;
  summary: string | null;
  status: string;
  errorMessage: string | null;
  before: unknown;
  after: unknown;
  amazonRequest: unknown;
  amazonResponse: unknown;
};

export type AuditTrailListData = {
  items: AuditTrailEvent[];
  total: number;
  page: number;
  pageSize: number;
};

export type AuditTrailListParams = {
  profileId?: string;
  source?: string;
  from?: string;
  to?: string;
  q?: string;
  page?: number;
  pageSize?: number;
};

export const auditTrailApi = {
  list: (params: AuditTrailListParams): Promise<ApiResponse<AuditTrailListData>> =>
    api
      .get('/api/v1/audit-trail', {
        params: {
          profileId: params.profileId || undefined,
          source: params.source || undefined,
          from: params.from || undefined,
          to: params.to || undefined,
          q: params.q || undefined,
          page: params.page ?? 1,
          pageSize: params.pageSize ?? 50,
        },
      })
      .then((res) => res.data),
};
